export const LIST = "AGENT_COMMISSION_LIST";
export const DETAILS = "AGENT_COMMISSION_DETAILS";
export const UPDATE = "AGENT_COMMISSION_UPDATE";
export const STORE = "AGENT_COMMISSION_STORE";